import { inject, injectable } from "tsyringe";
import { ViewModel } from "../../lib/vvm";
import {
  type INavigationStore,
  NAVIGATION_STORE_TOKEN,
  Screens,
} from "../../stores/navigation";

export interface LayoutViewProps {
  backTo?: Screens;
  title?: string;
}

@injectable()
export class LayoutViewModel extends ViewModel<unknown, LayoutViewProps> {
  constructor(
    @inject(NAVIGATION_STORE_TOKEN)
    private readonly navigationStore: INavigationStore,
  ) {
    super();
  }

  get title(): string | undefined {
    return this.viewProps.title;
  }

  goBack = (): void => {
    this.navigationStore.setScreen(this.viewProps.backTo || Screens.Main);
  };
}
